import { useNavigate } from "react-router-dom";
import { useData } from "@/context/DataContext";
import { motion } from "framer-motion";

export default function CategoryChips({ active }) {
  const navigate = useNavigate();
  const { categoriesResolved } = useData();
  return (
    <div className="no-scrollbar -mx-5 flex gap-2 overflow-x-auto px-5 py-1" data-testid="category-chips">
      {categoriesResolved.map((c) => {
        const isActive = active === c.slug;
        return (
          <motion.button
            key={c.slug}
            whileTap={{ scale: 0.94 }}
            data-testid={`category-chip-${c.slug}`}
            onClick={() => navigate(`/categoria/${c.slug}`)}
            className={`flex shrink-0 items-center gap-1.5 rounded-full px-4 py-2 text-sm font-bold transition-colors ${
              isActive ? "bg-[#1A1A1A] text-white" : "bg-[#F3F0E6] text-[#1A1A1A]"
            }`}
          >
            <c.Icon size={15} style={{ color: isActive ? "#fff" : c.color }} strokeWidth={2.4} />
            {c.label}
          </motion.button>
        );
      })}
    </div>
  );
}
